import request from '@/utils/request'

export function GetPageList(data) {
  return request({
    url: 'RunGroup/GetPageList',
    method: 'post',
    data,
  })
}


export function DelGroup(data) {
  return request({
    url: 'RunGroup/DelGroup',
    method: 'post',
    data,
  })
}

export function Save(data) {
  return request({
    url: 'RunGroup/Save',
    method: 'post',
    data,
  })
}

export function AddMember(data) {
  return request({
    url: 'RunGroup/AddMember',
    method: 'post',
    data,
  })
}


export function RemoveMember(data) {
  return request({
    url: 'RunGroup/RemoveMember',
    method: 'post',
    data,
  })
}

export function SetManage(data) {
  return request({
    url: 'RunGroup/SetManage',
    method: 'post',
    data,
  })
}

export function getGroupMembers(data) {
  return request({
    url: 'RunGroup/getGroupMembers',
    method: 'post',
    data,
  })
}

